import { UiColors } from "../../../../config/ui/colors";

export const DIRECT_MEMBERS_MANUFACTURING_SITES_IN_EUROPE_CHART_DATA_KEYS = [
	{
		name: "manufacturingSites",
		color: UiColors.charts.secondary,
	},
];
